import { FooterContainer } from './styles/FooterContainer.sytled'

function Footer() {
	return (
		<FooterContainer>
			<a href='https://github.com/hiredtocode/sexybrain'>
				<span>Designed & Built by Jason Han</span>
			</a>
		</FooterContainer>
	)
}

export default Footer
